// extracted by mini-css-extract-plugin
export var accent = "Navbar-module--accent--e0db3";
export var alert = "Navbar-module--alert--15af0";
export var badge = "Navbar-module--badge--f4d20";
export var badgeAnchor = "Navbar-module--badgeAnchor--9de33";
export var card = "Navbar-module--card--afb49";
export var caret = "Navbar-module--caret--36575";
export var flyout = "Navbar-module--flyout--72eff";
export var flyoutTitle = "Navbar-module--flyoutTitle--51920";
export var frame = "Navbar-module--frame--43cf6";
export var fullWidth = "Navbar-module--fullWidth--10ad1";
export var group = "Navbar-module--group--ccbb3";
export var horizontal = "Navbar-module--horizontal--637ef";
export var icon = "Navbar-module--icon--f76b5";
export var item = "Navbar-module--item--6f8c2";
export var label = "Navbar-module--label--ed9bb";
export var logo = "Navbar-module--logo--136bd";
export var newBadge = "Navbar-module--newBadge--7e2fa";
export var root = "Navbar-module--root--9bf4e";
export var scroll = "Navbar-module--scroll--05c9e";
export var skeletonIcon = "Navbar-module--skeletonIcon--13bc9";
export var skeletonLabel = "Navbar-module--skeletonLabel--5cb6e";
export var skeletonPulse = "Navbar-module--skeleton-pulse--83090";
export var standard = "Navbar-module--standard--e8fc4";
export var sub = "Navbar-module--sub--489b3";
export var subItem = "Navbar-module--subItem--66f93";
export var subItemIn = "Navbar-module--sub-item-in--7964b";
export var vertical = "Navbar-module--vertical--ed5c8";
export var viewport = "Navbar-module--viewport--cdc2a";